interface HtmlProps {
  code?: string;
}

export function HtmlBlock({ props }: { props: HtmlProps }) {
  if (!props.code) return null;
  return <div className="w-full" dangerouslySetInnerHTML={{ __html: props.code }} />;
}
